// extracted by mini-css-extract-plugin
export default {"component":"login_component__aV211"};